// import React from 'react'
import ReactDom from 'react-dom';

export default function seoHydrate(selector, component) {
  ReactDom.hydrate(component, selector);
}
